import { Check } from "lucide-react";

// Segmented step progress for the booking wizard.
export default function StepProgress({ steps, current }) {
  return (
    <div data-testid="step-progress" className="w-full">
      <div className="flex items-center gap-2">
        {steps.map((label, i) => {
          const done = i < current;
          const active = i === current;
          return (
            <div key={label} className="flex-1">
              <div
                className={`h-1.5 rounded-full transition-colors duration-500 ${
                  done ? "aurora-gradient" : active ? "bg-primary" : "bg-muted"
                }`}
              />
              <div className="mt-2 flex items-center gap-1.5">
                <span
                  className={`grid place-items-center h-4 w-4 rounded-full text-[10px] font-bold transition-colors ${
                    done ? "aurora-gradient text-white" : active ? "bg-primary text-white" : "bg-muted text-muted-foreground/70"
                  }`}
                >
                  {done ? <Check className="h-2.5 w-2.5" /> : i + 1}
                </span>
                <span className={`text-xs font-medium hidden sm:block ${active || done ? "text-foreground" : "text-muted-foreground/70"}`}>
                  {label}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
